import { FinancialAccount } from "@common/types/financialAccount";
import { financialAccountIsErrored } from "@helpers/financialAccount";
import { AccountsTableRow } from "./accountsView.types";

export function getEntityAccounts(row: AccountsTableRow): FinancialAccount[] {
    return row.accounts
        .map((accountRow) => accountRow.account)
        .filter((account): account is FinancialAccount => Boolean(account));
}

export function hasFailedConnection(account: FinancialAccount): boolean {
    if (account.disabled) {
        return false;
    }

    return financialAccountIsErrored(account);
}
